function subInCart() {
  // Returns True if there is a subscription in cart, returns false if not (or error)
  var check = false;
  $.ajax({
    url: '/cart.js',
    async: false,
    dataType: 'json',
    success: function(cart) {
      cart.items.forEach(function(item, index, arr) {
        if (item.hasOwnProperty('selling_plan_allocation')) {check=true}
      });
    }
  });
  return check
}

$(document).ready(function() {
  // Check if subscription selected when Add to Cart button is pressed and confirm user wants a subscription before adding to cart.
  $('#AddToCart--product-template').click(function() {
    var checked_sls_option = document.querySelector("div.seal-col.seal-col-radio > div > input[type='radio']:checked");
	if (checked_sls_option.getAttribute('data-type') == "subscription" && !subInCart()) {
	  if (confirm('Please confirm that you want to order a recurring delivery subscription!\nIf not, please select the "One-Time Purchase" option.')) {
	    $(this).submit();
	  } else {
	    return false;
	  }
	}
  });

  // Giftit Gift Message Window changes
  /*$('#giftMessageSelectContainer').before('<div id="giftMessageSelectLabel">Click here for options!</div>'); COMMENTED OUT BECAUSE NO LABEL NEEDED WITH ONLY 1 OPTION */
  $('#textfield_message').attr('placeholder','Write your personal gift message here!');
});

//Edits sale tags on Collection Pages to just say "ON SALE!"
$(document).ready(function() {
  var saleTags = $('div.tag-wrapper > span > span.tag-text').get();
  saleTags.forEach((element, index) => {
    element.textContent = "ON SALE!";
  });
});

// Add Message to Announcement Bar
/*$(function () {
  $('.announcement-wrapper > span').after(
    '<span style="text-shadow: 0 0 10px yellow;">OVERSTOCK SALE! <a href="https://matthatjerky.com/collections/all-beef-jerky/products/roasted-garlic-beef-jerky?variant=39570180440118">12 OZ Roasted Garlic</a> is $20 OFF!</span>'
  );
});*/

// Hides the "One-Time Purchase" options and selects the Subscription options on the Bundler Landing Page
document.addEventListener('sealsubs:subscription_widget_created', function(e) {
  console.log("Subscription Widget Created.");
  var isBundlerLandingPage = document.getElementsByClassName('bndlr-landing-page').length > 0 ? 1 : 0;
  if (isBundlerLandingPage) {
    $('div.sls-purchase-options-container > div:not([data-selling-plan-group])').hide();
    var subRadios = $('div.sls-purchase-options-container > div:not(.sls-disabled-option-container)[data-selling-plan-group] > div > div.seal-col.seal-col-radio').get();
    subRadios.forEach((element, index) => {
      setTimeout(() => { element.click(); }, index * 100); // Delays each click by 100ms or else this doesn't work
    });
  }
});

// Add qty input field to Bundler app
document.addEventListener('bundler:bundle_widget_created', function(e) {
  console.log("Bundler Widget Created.");
  $('.bndlr-bottom-pusher').after('<input class="bndlr-product-qty" type="number" value="1" min="0" step="1">');
  $(".bndlr-product-qty").on("input", function() {
    $(this).parent().attr('data-quantity',$(this).val());
  });
});

// Initialize accordion if present on FAQ page
$(function () {
  var isFAQPage = document.getElementById('faqpage');
  if (isFAQPage) {
    $("#faq-accordion").accordion({
      heightStyle: "content",
      icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" }
    });
  }
});

//Nutrition Facts Scripts
function openTabBruce(evt, cityName) {
  var i, tabcontent_bruce, tablinks_bruce;
  tabcontent_bruce = document.getElementsByClassName("tabcontent_bruce");
  for (i = 0; i < tabcontent_bruce.length; i++) {
    tabcontent_bruce[i].style.display = "none";
  }
  tablinks_bruce = document.getElementsByClassName("tablinks_bruce");
  for (i = 0; i < tablinks_bruce.length; i++) {
    tablinks_bruce[i].className = tablinks_bruce[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
$(function () {
  if (document.getElementById('nutritionpage')) {
    // Get the element with id="defaultOpen" and click on it
    //document.getElementById("defaultOpen").click();
    $("#defaultOpen").trigger("click");
  }
});

console.log("MHJ Custom Scripts Loaded.");